<template>
  <button
    type="button"
    class="ck-toggle"
    :aria-pressed="theme === 'light'"
    :aria-label="theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'"
    @click="toggle($event.currentTarget)">
    <span class="ck-toggle__knob"></span>
  </button>
</template>

<script>
import { useTheme } from '@/composables/theme';

// tsuki / hi: a pale-tea (shiracha) crescent in the dark theme, a vermilion sun in the light one.
export default {
  name: 'ThemeToggle',
  setup() {
    const { theme, toggle } = useTheme();
    return { theme, toggle };
  }
}
</script>
